import { Formik } from "formik";
import React from "react";
import * as Yup from "yup";
import CustomSelect from "../CustomSelect";
import { Button } from "../ui/button";
import { assignStaffRoleAndEntity, getRoles } from "src/api/settings";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useDashboardContext } from "src/context/DashboardContext";
import { usePortalContext } from "src/context/PortalContext";
import { showSuccessToast } from "src/lib/utils";

const validationSchema = Yup.object().shape({
	role_id: Yup.string().required("This field is required"),
	store_or_warehouse_id: Yup.string().required("This field is required"),
});

const EditStaffRole = ({ staff }) => {
	const queryClient = useQueryClient();
	const closePortal = usePortalContext();
	const { entities } = useDashboardContext();

	const { data: rawRoles } = useQuery({
		queryKey: ["roles"],
		queryFn: () => getRoles(),
		suspense: true,
	});
	const roles = rawRoles?.data ?? [];

	const { mutate, isLoading } = useMutation(assignStaffRoleAndEntity, {
		onSuccess: ({ message }) => {
			showSuccessToast(message);
			queryClient.invalidateQueries(["teams"]);
			closePortal();
		},
	});

	const entityOptions = entities?.map(({ id, name }) => ({ label: name, value: String(id) }));
	const roleOptions = roles?.map(({ id, name }) => ({ label: name, value: String(id) }));

	const initialValues = {
		user_id: staff?.id,
		role_id: staff?.user_type_id ?? "",
		store_or_warehouse_id: staff?.store_or_warehouse_id ?? "",
	};

	return (
		<Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={(values) => mutate(values)}>
			{({ values, setFieldValue, handleSubmit }) => (
				<form onSubmit={handleSubmit} className="tw-grid tw-gap-6">
					<CustomSelect
						name="role_id"
						label="Select Role"
						placeholder="Select Role"
						value={values.role_id}
						onChange={(value) => setFieldValue("role_id", value)}
						options={roleOptions}
					/>
					<CustomSelect
						name="store_or_warehouse_id"
						label="Select Warehouse/Storefront"
						placeholder="Select Warehouse/Storefront"
						value={values.store_or_warehouse_id}
						onChange={(value) => setFieldValue("store_or_warehouse_id", value)}
						options={entityOptions}
					/>
					<Button disabled={isLoading}>Save changes</Button>
				</form>
			)}
		</Formik>
	);
};

export default EditStaffRole;
